/**
 * Partitions a query params object into a `result` and `removed` sets such that
 * `removed` contains all params with `undefined`, `null`, or empty string values
 * and `result` is the difference between `params` and `removed`.
 * @param {*} params results to partition
 */
const sanitizeParams = (params) =>
    Object.entries(params).reduce(
        (acc, pair) => {
            const key = pair[0];
            const value = pair[1];
            if (
                typeof value === 'undefined' ||
                value === null ||
                value === ''
            ) {
                acc.removed[key] = value;
            } else {
                acc.result[key] = value;
            }
            return acc;
        },
        {removed: {}, result: {}}
    );

const FILTER_PREFIX = 'filter:';
/**
 * Get refinementKey query param from the filters
 */
const getRefinementKeyQueryParam = (filters) => {
    if (Array.isArray(filters) && filters.length) {
        const availableFilters = filters.reduce((allFilters, filter) => {
            if (filter.includes(FILTER_PREFIX)) {
                allFilters.push(Number(filter.replace(FILTER_PREFIX, '')));
            }
            return allFilters;
        }, []);

        return availableFilters.length
            ? {refinementKey: availableFilters}
            : null;
    }
    return null;
};

module.exports = {sanitizeParams, getRefinementKeyQueryParam};
